import { useTranslation } from 'react-i18next';

import ConfirmDialog from '@/components/ConfirmDialog';

type ConfirmDeleteCVDialogProps = {
  cvId: string | null;
  onClose: () => void;
  onConfirm: (cvId: string) => Promise<void>;
  isDeleting?: boolean;
};

export default function ConfirmDeleteCVDialog({
  cvId,
  onClose,
  onConfirm,
  isDeleting = false,
}: ConfirmDeleteCVDialogProps) {
  const { t } = useTranslation();

  if (!cvId) return null;

  return (
    <ConfirmDialog
      open={!!cvId}
      onOpenChange={open => {
        if (!open) onClose();
      }}
      title={t('dashboard.cvList.delete.confirmTitle')}
      description={t('dashboard.cvList.delete.confirmDescription')}
      confirmLabel={t('dashboard.cvList.delete.confirm')}
      cancelLabel={t('common.cancel')}
      confirmVariant="destructive"
      isLoading={isDeleting}
      onConfirm={() => {
        void onConfirm(cvId);
      }}
    />
  );
}
